module.exports = __webpack_public_path__ + "static/media/help_2.b21dda2f.png";